function googleErrorMessage(string) {
  let errorMessage = string
  errorMessage = errorMessage.replace(/_/g, ' ').replace('user', 'User')
  return errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1)
}

export function snakeToPascalCase(string) {
  const arrString = string.split('_').map(arrStr => {
    return arrStr.slice(0, 1).toUpperCase() + arrStr.slice(1, arrStr.length)
  })

  return arrString.join(' ')
}

export default googleErrorMessage
